import React, { memo } from 'react'
import { ReactComponent as Logo } from '../assets/logo_small.svg'
import { ReactComponent as LogoTitle } from '../assets/logo_title.svg'
import { ReactComponent as ArrowRight } from '../assets/arrow_right.svg'
import { LeftSidebarProps } from './Layout.types'
import { Link } from 'react-router-dom'
import { NavMenuSlot } from './slots'
import { Version } from './Version/Version'
import * as S from './LeftSidebar.styles'

export const LeftSidebar: React.FC<LeftSidebarProps> = memo(
  ({ isOpen, toggle }) => {
    return (
      <S.StyledLeftSidebar $isOpen={isOpen}>
        <S.LogoLink as={Link} to="/">
          <S.Logo as={Logo} $variant="short" $isOpen={isOpen} />
          <S.Logo as={LogoTitle} $variant="full" $isOpen={isOpen} />
        </S.LogoLink>
        <Version isOpen={isOpen} />
        <S.NavMenuSlotWrapper>
          <NavMenuSlot isOpen={isOpen} />
        </S.NavMenuSlotWrapper>
        <S.BottomPanel onClick={toggle}>
          <S.ArrowIcon as={ArrowRight} $isOpen={isOpen} />
        </S.BottomPanel>
      </S.StyledLeftSidebar>
    )
  }
)

LeftSidebar.displayName = 'LeftSidebar'
